import React from "react";

export default function Wallet() {
  const phoneNumber = "6302199418";
  const emailAddress = "andrewtho5942@gmail.com";

  return (
    <main className="min-h-screen bg-slate-100 px-4 py-4">
      <div className="mx-auto max-w-md overflow-hidden rounded-3xl bg-white shadow-xl">
        <div className="bg-slate-900 px-6 py-10 text-center text-black">
          <h1 className="text-3xl font-bold">Wallet Found?</h1>

          <p className="mt-3 text-slate-300">
            Thank you for taking the time to return it.
          </p>
        </div>

        <div className="space-y-6 px-6 py-8">
          <section className="text-center">
            <p className="text-lg leading-relaxed text-slate-700">
              This wallet belongs to
            </p>

            <h2 className="mt-1 text-2xl font-bold text-slate-900">
              Andrew Thompson
            </h2>

            <p className="mt-4 leading-relaxed text-slate-600">
              Please contact me using one of the options below. I will arrange
              a convenient way to retrieve the wallet.
            </p>
          </section>

          <section className="rounded-2xl border border-amber-200 bg-amber-50 p-5 text-center">
            <p className="text-sm font-semibold uppercase tracking-wider text-amber-700">
              Reward Available
            </p>

            <p className="mt-2 text-amber-950">
              A reward will be provided for the safe return of this wallet.
            </p>
          </section>

          <div className="space-y-3">
            <a
              href={`tel:${phoneNumber}`}
              className="flex w-full items-center justify-center rounded-xl bg-blue-600 px-5 py-4 text-base font-semibold text-white transition hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-200"
            >
              Call Me
            </a>

            <a
              href={`sms:${phoneNumber}`}
              className="flex w-full items-center justify-center rounded-xl bg-slate-900 px-5 py-0 text-base font-semibold text-black transition hover:bg-slate-800 focus:outline-none focus:ring-4 focus:ring-slate-300"
            >
              Send a Text
            </a>

            <a
              href={`mailto:${emailAddress}?subject=I found your wallet`}
              className="flex w-full items-center justify-center rounded-xl border border-slate-300 bg-white px-5 py-4 text-base font-semibold text-slate-800 transition hover:bg-slate-50 focus:outline-none focus:ring-4 focus:ring-slate-200"
            >
              Send an Email
            </a>
          </div>

          <section className="rounded-2xl bg-slate-100 p-5">
            <h3 className="font-semibold text-slate-900">
              Please keep the wallet secure
            </h3>

            <p className="mt-2 text-sm leading-relaxed text-slate-600">
              Please do not post pictures of the wallet, identification cards,
              or other personal information online.
            </p>
          </section>

          <p className="text-center text-xs text-slate-400">
            This page does not collect or store your location or personal
            information.
          </p>
        </div>
      </div>
    </main>
  );
}